import { useSession } from '@/lib/auth-client'

export function useImpersonationStatus() {
  const { data: session } = useSession()

  // Better Auth agrega el campo impersonatedBy cuando hay impersonación activa
  const isImpersonating = !!session?.session?.impersonatedBy

  return {
    isImpersonating,
    impersonatedBy: session?.session?.impersonatedBy || null,
    currentUser: session?.user || null,
  }
}
